const init = () => {

    var $navTabs = $('.nav-tabs a');
    if ($navTabs.length < 1) return;

    // scrollable navtabs
    PubSub.subscribe('app:resized', overflowClassCheck);
    var $activeNav = $navTabs.filter('.is-active');
    var activeIndex = $activeNav.index();
    var $navTabScroller = $navTabs.parents('.nav-tabs__scroller');
    var sw = $navTabScroller[0].scrollWidth;
    if (activeIndex > 0) {
        var $prevTab = $navTabs.eq(activeIndex - 1);
        var prevX = $prevTab.position().left;
        var prevW = $prevTab.outerWidth();
        $navTabScroller.scrollLeft(prevX + (prevW / 2), 0);
    }

    function overflowClassCheck() {
        // $.outerWidth may return a fraction in some cases ($ docs)
        sw = parseInt($navTabScroller[0].scrollWidth, 10);
        nw = parseInt($navTabScroller.outerWidth(), 10);
        if (sw > nw) {
            $navTabScroller.addClass('has-overflow');
        } else {
            $navTabScroller.removeClass('has-overflow');
        }
    }


    //
    // NOTE: functions below this check only run if nav-tabs are toggling page content via .js-nav-tab
    //
    
    var $tabs = $('.js-nav-tab');
    if ($tabs.length < 1) {
        return;
    }

    var $triggers = $('.js-nav-tab-trigger');

    $navTabs.click(function(e) {

        // cancel href
        e.preventDefault();

        var $that = $(this);
        if (!$that.hasClass('is-active')) {
            var index = $that.index();
            updateUI(index);
            window.history.pushState({ navIndex: index }, '', $that.attr('href'));

            // Trigger lazy loading migration for newly visible content
            setTimeout(function() {
                if (window.app && window.app.migrateBlazy) {
                    window.app.migrateBlazy();
                }
            }, 0);
        }
    });

    $triggers.click(function(e) {
        $navTabs.eq($(this).data('trigger-index')).click();
    });

    function updateUI(index) {
        var $newTab = $tabs.eq(index);
        $navTabs.add($tabs).removeClass('is-active');
        $navTabs.eq(index).add($newTab).addClass('is-active');
    }

    window.onpopstate = function(e) {
        var index = (e.state === null) ? 0 : e.state.navIndex;
        updateUI(index);
    };
}

export default init;